import { configureStore } from '@reduxjs/toolkit';
import userSlice from './slices/userSlice';
import toastSlice from './slices/toastSlice';

export const store = configureStore({
  reducer: {
    user: userSlice,
    toast: toastSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
